<template>
  <div class="card bg-light d-flex flex-fill">
    <div class="card-header titulos-conteudo mb-2">{{camposNotificacao.f_summary}}</div>
    <div class="card-body pt-0">
      <div class="row">
        <div class="col-12" >
          <span>
            <small class="textoNegrito">{{obterMensagemNotificacao(camposNotificacao.f_type)}}</small>
            <br/><br/>
            <small class="text-muted">Convidado: {{camposNotificacao.f_user_name}}</small>
            <br/>
            <small class="text-muted">E-mail: {{camposNotificacao.f_participant_email}}</small>
            <br/>
            <small class="text-muted">Início: {{formatarDataHora(camposNotificacao.f_dtstart)}}</small>
          </span>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="text-right">
        <b-button class="botoes" variant="outline-success btn-sm mr-1" @click="obterRetornoNotificacaoConvite(camposNotificacao.f_id)" :disabled="desabilitar">Ok</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import util from '@/util'

export default {
  name: 'notificacoesConvites',

  props: {
    camposNotificacao: [Object],
    desabilitar: Boolean
  },

  data: () => {
    return {
      mensagemConviteAceito: 'Convite aceito',
      mensagemConviteNegado: 'Convite negado',
      flagsDeControle: {
        carregandoDados: {
          convites: {
            status: false,
            mensagem: ''
          }
        },
        manipulandoDados: {
          convites: {
            status: false,
            mensagem: ''
          }
        }
      }
    }
  },
  mounted () {
  },

  methods: {
    obterRetornoNotificacaoConvite (id) {
      let resposta = {
        'f_id': id
      }
      this.$emit('retornoDoConvite', resposta)
    },

    formatarDataHora (data) {
      let dataFormatada = util.formatarData(data, 'DD/MM/YYYY HH:mm')
      return dataFormatada
    },

    obterMensagemNotificacao (tipoNotificacao) {
      switch (tipoNotificacao) {
        case 1:
          return this.mensagemConviteAceito

        case 2:
          return this.mensagemConviteNegado
      }
    }
  }
}
</script>

<style scoped>
@import "./scss/inicio.scss";
</style>
